import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {promoterLogin} from '../core/_requests'
import {useAuth} from '../../auth'
import Skeleton from 'react-loading-skeleton'

export function ReferralRK({key}: {key: number}) {
  const {formatMessage} = useIntl()
  const [loading, setLoading] = useState(false)
  const {currentUser} = useAuth()
  const [accessToken, setAccessToken] = useState('')
  const iframeSrc = `${process.env.REACT_APP_PROMOTER_CUSTOM_DOMAIN}/iframe?tk=${accessToken}`

  const getPromoterLoginAccess = async () => {
    try {
      setLoading(true)
      const {
        data: {success, data, errors},
      } = await promoterLogin()
      if (success) {
        setAccessToken(data.result.access_token)
        setLoading(false)
      } else {
        setLoading(false)
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    getPromoterLoginAccess()
  }, [currentUser]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='card rounded-1 p-2' key={key}>
      <div className='card-body'>
        {loading || !accessToken ? (
          <div className='h-100'>
            <Skeleton
              height={800}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
              className='mb-0'
            />
          </div>
        ) : (
          <iframe
            title='Invite Friends & Start Earning'
            allow='clipboard-write'
            height='850px'
            width='100%'
            frameBorder='0'
            src={iframeSrc}
          ></iframe>
        )}
      </div>
    </div>
  )
}
